import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, IsUUID, Min, ValidateIf, ValidateNested } from "class-validator";
import { EventPriceTypesEnum, DiscountTypeEnum } from "../../../../enums";
import { IsHigherThan } from '../../../../decorators';

export class SetEventPriceDto {
	@IsOptional()
	@IsUUID()
	public id?: string;

	@IsOptional()
	@IsUUID()
	public basePriceId?: string;

	@IsNumber()
	@IsInt()
	@Min(0)
	@IsNotEmpty()
	public priceAmount: number;

	@IsString()
	@IsNotEmpty()
	public tierName: string;

	@IsOptional()
	@IsEnum(EventPriceTypesEnum)
	public tierTypeId?: EventPriceTypesEnum;

	@ValidateIf(o => o.tierTypeId === EventPriceTypesEnum.Group)
	@IsNumber()
	@IsInt()
	@Min(2)
	@IsNotEmpty()
	public ticketsPerGroup?: number | null;

	@IsOptional()
	@IsNumber()
	@IsInt()
	@Min(1)
	public minTicketsPerOrder?: number | null;

	@IsOptional()
	@IsNumber()
	@IsInt()
	@IsHigherThan('minTicketsPerOrder')
	public maxTicketsPerOrder?: number | null;

	@IsOptional()
	@IsString()
	public currency?: string;

	@IsOptional()
	@IsString()
	public tierDescription?: string;

	@IsOptional()
	@IsBoolean()
	public isBaseTier?: boolean;

	@IsOptional()
	@IsNumber()
	public maxTickets?: number | null;

	@IsOptional()
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => SetEventPriceToMembershipsDto)
	public setEventPricesToMemberships?: SetEventPriceToMembershipsDto[];

	@IsOptional()
	@IsInt()
	@Min(0)
	public order: number;
}

/**
 * @example Can join for free: { amount: 100, type: 'percentage' }
 * @example Half the price of the ticket: { amount: 50, type: 'percentage' }
 * @example Full price: { amount: 0, type: 'percentage' } OR NO RECORD
 * @example Custom: { amount: 1000, type: 'fixed' } OR { amount: 25, type: 'percentage' }
 */
export class SetEventPriceToMembershipsDto {
	@IsUUID()
	@IsNotEmpty()
	public membershipId: string;

	@IsInt()
	@IsNotEmpty()
	public amount: number;

	@IsEnum(DiscountTypeEnum)
	@IsNotEmpty()
	public type: DiscountTypeEnum;
}
